import store from '@/store'
import i18n from '../../lang'
import moment from 'moment'
import { getOffers, getOffer, acceptOffer, declineOffer, createOffer, updateOffer, applyOffer, refuseOffer, deleteOffer,
         countOffersByStatus, getNumberPotentialCandidates, getPotentialCandidates, downloadOffers, getNumberOfRefutes,
         getCandidatesRefusingOffer, getPotentialCandidatesWithoutRefutes, updateAndRepublishOffer, getSelectingCandidatesCount,
         getRefusedCandidatesCount, getRefusedCandidates, cancelOffer, sendOfferToStaff, canSendOfferToStaff, getManagerInCopy } from '@/backend/offers'

const SET_OFFER = 'SET_OFFER';
const ADD_PERIOD = 'ADD_PERIOD';
const CLONE_OFFER = 'CLONE_OFFER';
const SET_LIST = 'SET_LIST';
const SET_TAB = 'SET_TAB';
const SET_PAGE = 'SET_PAGE';
const SET_SORT_FIELD = 'SET_SORT_FIELD';
const SET_SORT_ORDER = 'SET_SORT_ORDER';
const SET_FILTERS = 'SET_FILTERS';
const SET_KEEP_FILTERS = 'SET_KEEP_FILTERS';
const SET_CHECKED_CANDIDATES_LIST = 'SET_CHECKED_CANDIDATES_LIST';
const COUNT_BY_STATUS = 'COUNT_BY_STATUS';
const RESET_CHECKED_CANDIDATES_LIST = "RESET_CHECKED_CANDIDATES_LIST";
const RESET_OFFER = "RESET_OFFER";
const SET_POTENTIAL_CANDIDATE_COUNT = 'SET_POTENTIAL_CANDIDATE_COUNT';
const SET_CANDIDATES_LIST = 'SET_CANDIDATES_LIST';
const SET_REFUTES_COUNT = 'SET_REFUTES_COUNT';
const SET_REFUSED_CANDIDATES = 'SET_REFUSED_CANDIDATES';
const SET_MANAGERS_IN_COPY = 'SET_MANAGERS_IN_COPY';
const SET_REFUSED_CANDIDATES_COUNT = 'SET_REFUSED_CANDIDATES_COUNT';
const SET_SELECTING_CANDIDATES_COUNT = 'SET_SELECTING_CANDIDATES_COUNT'
const SET_CANDIDATES_LIST_PAGE = 'SET_CANDIDATES_LIST_PAGE';
const SET_LOAD_FORM = 'SET_LOAD_FORM';
const SET_ENTITY_OFFER = 'SET_ENTITY_OFFER';
const SET_CAN_SEND_OFFER_STAFF = 'SET_CAN_SEND_OFFER_STAFF';
const OFFER_LIST_LOADING = 'OFFER_LIST_LOADING';
const OFFER_EXPORT_LOADING = 'OFFER_EXPORT_LOADING';
const UPDATE_SEARCH_WORDS = 'UPDATE_SEARCH_WORDS';
const RESET_CURRENT_PAGE = 'RESET_CURRENT_PAGE';

function default_offer_period() {
  return {
    start_at: moment(),
    end_at: moment(),
    effective_work_minutes: 0
  }
}

const DEFAULT_REPLACEMENT_DETAIL_ATTRIBUTES = {
  replacement_motive_id: null,
  replacement_motive_name: "",
  details: ""
}
const DEFAULT_OFFER_ATTRIBUTES = {
  resource_type: 'intern',
  mode: 'choice_mode',
  offer_periods_attributes: [Object.assign({}, default_offer_period())],
  include_proposed_candidates: false,
  include_hub_services: false,
  entity: {},
  replaced_service: {},
  replaced_occupation: {},
  replacement_detail_attributes: Object.assign({}, DEFAULT_REPLACEMENT_DETAIL_ATTRIBUTES),
  applied_candidates: [],
  validated_candidate: {},
  searched_occupations: [],
  author: {
    phone: '',
    email: ''
  },
  replacementMotive: '',
  replaced_person: '',
  replaced_person_salary_category: '',
  salary: '',
  contract: null
}

const state = {
  minSearchLength: 3,
  searchWord: '',
  offerList: {
    data: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
    selectedTab: 'all',
    sortField: 'start_at',
    sortOrder: 'asc',
    filters: {},
    keepFilters: false,
    loading: false,
    exportLoading: false
  },
  numberByStatus: { all: 0, published: 0, waiting: 0, draft: 0, passed: 0, expired: 0, validated: 0, expired_and_validated: 0, expired_and_not_validated: 0, cancelled: 0 },
  offer: {
    entity: {},
    replaced_service: {},
    replaced_occupation: {},
    applied_candidates: [],
    validated_candidate: {},
    include_proposed_candidates: false,
    include_hub_services: false,
    searched_occupations: [],
    replacement_detail_attributes: {
      replacement_motive_id: null,
      replacement_motive_name: "",
      details: ""
    },
    author: {
      phone: '',
      email: ''
    },
    replaced_person: '',
    replaced_person_salary_category: '',
    salary: '',
    managers_in_copy: '',
    edit_comment: ''
  },
  potentialCandidatesCount: 0,
  candidatesList: { data: [], total: 0, totalPages: 0, currentPage: 1 },
  candidatesIdsList: {},
  checkedCandidatesList: {},
  candidatesListPage: 1,
  refutesCount: 0,
  refusedCandidates: {
    list: [],
    overlap_candidate_ids: [],
    total: 0,
    totalPages: 0,
    currentPage: 0
  },
  refusedCandidatesCount: 0,
  refusedCandidatesPage: 1,
  offerStatusCancel: '',
  loadFormOffer: false,
  selectedEntity: null,
  selectingCandidatesCount: 0,
  canSendOfferStaff: false,
  managersInCopy: []
}

export const mutations = {
  [OFFER_LIST_LOADING] (state, loading) {
    state.offerList.loading = loading;
  },

  [OFFER_EXPORT_LOADING] (state, loading) {
    state.offerList.exportLoading = loading
  },

  [SET_OFFER] (state, offer) {
    offer.resource_type = offer.resource_type_key // api returns resource_type with translated value
    if(offer.replacement_detail_attributes == null) {
      offer.replacement_detail_attributes = {
        replacement_motive_id: null,
        replacement_motive_name: "",
        details: ""
      }
    }
    state.offer = offer;
  },

  [CLONE_OFFER] (state, offer) {
    let cloneOffer = {
      mode: 'choice_mode',
      resource_type: offer.resource_type_key,
      entity: offer.entity,
      replaced_service: offer.replaced_service,
      replaced_occupation: offer.replaced_occupation,
      include_proposed_candidates: offer.include_proposed_candidates,
      include_hub_services: offer.include_hub_services,
      searched_occupations: offer.searched_occupations,
      effective_work_minutes: offer.effective_work_minutes,
      details: offer.details,
      offer_periods_attributes: [Object.assign({}, default_offer_period())],
      replacement_detail_attributes: offer.replacement_detail_attributes
    }
    if(offer.replacement_detail_attributes == null) {
      cloneOffer.replacement_detail_attributes = {
        replacement_motive_id: null,
        replacement_motive_name: "",
        details: ""
      }
    }

    state.offer = cloneOffer
  },

  [UPDATE_SEARCH_WORDS] (state, searchWord) {
    state.searchWord = searchWord
  },

  [SET_LIST] (state, response) {
    state.offerList.data = response.data
    state.offerList.total = response.total
    state.offerList.totalPages = response.totalPages
  },

  [COUNT_BY_STATUS] (state, response){
    state.numberByStatus.all = response.all
    state.numberByStatus.published = response.published
    state.numberByStatus.waiting = response.waiting
    state.numberByStatus.draft = response.draft
    state.numberByStatus.validated = response.validated
    state.numberByStatus.expired = response.expired
    state.numberByStatus.expired_and_validated = response.expired_and_validated
    state.numberByStatus.passed = response.passed
    state.numberByStatus.expired_and_not_validated = response.expired_and_not_validated
    state.numberByStatus.cancelled = response.cancelled
  },

  [SET_TAB] (state, tabName) {
    state.offerList.selectedTab = tabName
  },

  [SET_PAGE] (state, page) {
    state.offerList.currentPage = page
  },

  [SET_SORT_FIELD] (state, sortField) {
    state.offerList.sortField = sortField
  },

  [SET_SORT_ORDER] (state, sortOrder) {
    state.offerList.sortOrder = sortOrder
  },

  [SET_FILTERS] (state, filters) {
    state.offerList.filters = filters
  },

  [SET_KEEP_FILTERS] (state, value) {
    state.offerList.keepFilters = value
  },

  [SET_CHECKED_CANDIDATES_LIST] (state, value) {
    state.checkedCandidatesList[value.candidateId] = value.checked
  },

  [ADD_PERIOD] (state, date) {
    let newPeriods = state.offer.offer_periods_attributes.slice()
    let newPeriod = Object.assign({}, default_offer_period())
    let start_date = date
    let end_date = date
    start_date.minutes(moment().minutes())
    start_date.hours(moment().hours())
    end_date.minutes(moment().minutes())
    end_date.hours(moment().hours())
    newPeriod['start_at'] = start_date
    newPeriod['end_at'] = end_date
    newPeriods.push(newPeriod)
    state.offer.offer_periods_attributes = newPeriods.slice()
  },

  [RESET_OFFER] (state) {
    state.offer = Object.assign({}, DEFAULT_OFFER_ATTRIBUTES);
    state.offer.offer_periods_attributes = [Object.assign({}, default_offer_period())];
    state.offer.replacement_detail_attributes = Object.assign({}, DEFAULT_REPLACEMENT_DETAIL_ATTRIBUTES);
  },

  [RESET_CHECKED_CANDIDATES_LIST] (state) {
    state.checkedCandidatesList = {}
  },

  [RESET_CURRENT_PAGE] (state) {
    state.candidatesList.currentPage = 1
  },

  [SET_POTENTIAL_CANDIDATE_COUNT] (state, candidates_count) {
    state.potentialCandidatesCount = candidates_count
  },

  [SET_CANDIDATES_LIST] (state, response) {
    state.candidatesIdsList= {}
    for (let key in response.data.ids) {
      let value = response.data.ids[key]
      state.candidatesIdsList[key] = value
    }
    state.candidatesList.data = response.data.list
    state.candidatesList.total = response.total
    state.candidatesList.totalPages = response.totalPages
    state.candidatesList.currentPage = response.currentPage
  },

  [SET_REFUTES_COUNT] (state, refutesCount) {
    state.refutesCount = refutesCount
  },

  [SET_CANDIDATES_LIST_PAGE] (state, page) {
    state.candidatesListPage = page
  },

  [SET_REFUSED_CANDIDATES_COUNT] (state, refusedCandidatesCount) {
    state.refusedCandidatesCount = refusedCandidatesCount;
  },

  [SET_REFUSED_CANDIDATES] (state, refusedCandidates) {
    state.refusedCandidates = refusedCandidates;
  },

  [SET_MANAGERS_IN_COPY] (state, managersInCopy) {
    state.offer.managers_in_copy = managersInCopy;
    state.managersInCopy = managersInCopy;
  },

  [SET_SELECTING_CANDIDATES_COUNT] (state, selectingCandidatesCount) {
    state.selectingCandidatesCount = selectingCandidatesCount;
  },

  [SET_LOAD_FORM] (state, loadFormOffer) {
    state.loadFormOffer = loadFormOffer;
  },

  [SET_ENTITY_OFFER] (state, entity) {
    state.selectedEntity = entity
  },

  [SET_CAN_SEND_OFFER_STAFF] (state, canSendOfferStaff) {
    state.canSendOfferStaff = canSendOfferStaff
  }
}

export const actions = {
  resetOfferList({ commit }) {
    commit(SET_LIST, []);
  },
  loadOfferList({ commit }, params) {
    commit(OFFER_LIST_LOADING, true);

    return getOffers(params)
    .then(response => {
      if(response.data.length == 0 && state.offerList.currentPage > 1){
        params['page'] = state.offerList.currentPage - 1;
        store.dispatch('offers/loadOfferList', params)
      }else{
        let list = {
          data: response.data,
          total: response.headers['x-total'],
          totalPages: response.headers['x-total-pages'],
          currentPage: response.headers['x-page']
        }
        commit(SET_LIST, list);
        if(list.total == 0) {
          store.dispatch('noData/enable')
        } else {
          store.dispatch('noData/disable')
        }
        $("#main-content").scrollTop( 0 );
      }
      commit(OFFER_LIST_LOADING, false);
    })
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
      commit(OFFER_LIST_LOADING, false);
    })
  },
  countByStatus({ commit }, params) {
    return countOffersByStatus(params)
    .then(response => {
      commit(COUNT_BY_STATUS, response.data)
    })
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },
  selectTab({ commit}, tabname) {
    commit(SET_TAB, tabname)
  },
  setPage({ commit}, page) {
    commit(SET_PAGE, page)
  },
  setSortField({ commit }, sortField){
    commit(SET_SORT_FIELD, sortField)
  },
  setSortOrder({ commit }, sortOrder){
    commit(SET_SORT_ORDER, sortOrder)
  },
  setFilters({ commit }, filters){
    commit(SET_FILTERS, filters)
  },
  setKeepFilters({ commit }, value){
    commit(SET_KEEP_FILTERS, value)
  },
  updateCheckedCandidatesList({commit}, {candidateId, checked}) {
    let data = {candidateId: candidateId, checked: checked}
    commit(SET_CHECKED_CANDIDATES_LIST, data)
  },
  resetCheckedCandidatesList({commit}) {
    commit(RESET_CHECKED_CANDIDATES_LIST)
  },
  searchPotentialCandidates({commit}, {searchWord, replacedServices, affiliatedServices ,params}){
    commit(UPDATE_SEARCH_WORDS, searchWord)
    commit(RESET_CURRENT_PAGE)
    store.dispatch('offers/getPotentialCandidates', { offer: params,
                                                      search_keyword: searchWord,
                                                      response_for_web: true,
                                                      replaced_services: replacedServices,
                                                      affiliated_services: affiliatedServices,
                                                      page: 1 })
  },
  clearFilters({ commit }){
    commit(SET_FILTERS, {})
  },
  getOffer({ commit }, offerId) {
    return new Promise((resolve, reject) => {
      getOffer(offerId)
        .then( (response) => {
          commit(SET_OFFER, response.data);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
    }).catch(error =>{})
  },
  acceptOffer({ commit }, { offerId, userAppliedOfferId }) {
    return acceptOffer(offerId, userAppliedOfferId)
    .then( (response) => {
      commit(SET_OFFER, response.data);
      var message = {type: 'success', content: i18n.t('messages.offer_accepted')};
      store.dispatch('message/enable', message);
    })
    .catch(error =>{
      var message = {type: 'danger', content: error.response.data.error}
      store.dispatch('message/enable', message)
    })
  },

  applyOffer({ commit }, offerId) {
    return applyOffer(offerId)
    .catch(error =>{
      var message = {type: 'danger', content: error.response.data.message}
      store.dispatch('message/enable', message)
    })
  },

  refuseOffer({ commit }, offerId) {
    return refuseOffer(offerId)
    .catch(error =>{
      var message = {type: 'danger', content: error.response.data.error}
      store.dispatch('message/enable', message)
    })
  },

  declineOffer({ commit }, { offerId, userAppliedOfferId }) {
    return declineOffer(offerId, userAppliedOfferId)
    .then( (response) => {
      commit(SET_OFFER, response.data)
      let message = {type: 'success', content: i18n.t('messages.offer_declined')}
      store.dispatch('offers/getRefusedCandidatesCount', offerId)
      store.dispatch('offers/getRefusedCandidates', offerId)
      store.dispatch('message/enable', message)
    })
    .catch(error =>{
      var message = {type: 'danger', content: error.response.data.error}
      store.dispatch('message/enable', message)
    })
  },
  deleteOffer({ commit }, offerId) {
    return deleteOffer(offerId)
    .then( (response) => {
      var message = {type: 'success', content: i18n.t('messages.offer_deleted')};
      store.dispatch('message/enable', message);
      return response;
    })
    .catch(error =>{
      var message = {type: 'danger', content: error.response.data.error}
      store.dispatch('message/enable', message)
    })
  },
  cancelOffer({ commit }, {offerId, commentCancel}) {
    return new Promise((resolve, reject) => {
      cancelOffer(offerId, commentCancel)
      .then((response) => {
        commit(SET_OFFER, response.data);
        resolve()
      })
      .catch(error => {
        var message = {type: 'danger', content: error.response.data.error}
        store.dispatch('message/enable', message)
      })
    })
  },
  create({ commit }, { offer, shouldBePublished, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList }) {
    return new Promise((resolve, reject) => {
      createOffer(offer, shouldBePublished, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList)
      .then( (response) => {
        commit(RESET_OFFER);
        resolve()
      })
      .catch(error => {
        var message = { type: 'danger', content: error.response.data.error }
        store.dispatch('message/enable', message)
        reject(error)
      })
    })
  },
  update({ commit }, { offer, shouldBePublished, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList }) {
    return new Promise((resolve, reject) => {
      updateOffer(offer, shouldBePublished, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList)
      .then( (response) => {
        commit(RESET_OFFER);
        resolve()
      })
      .catch(error => {
        var message = { type: 'danger', content: error.response.data.error }
        store.dispatch('message/enable', message)
      })
    })
  },
  addPeriod({ commit }, date) {
    commit(ADD_PERIOD, date)
  },
  reset({ commit }, role) {
    commit(RESET_OFFER);
  },
  clone({ commit }, offerId) {
    return new Promise((resolve, reject) => {
      getOffer(offerId)
        .then( (response) => {
          commit(CLONE_OFFER, response.data);
          resolve()
        })
        .catch(error => {
          var message = { type: 'danger', content: error.response.data.error }
          store.dispatch('message/enable', message)
          reject(error)
        })
    })
  },
  saveDraft({ commit }, { offer, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList}) {
    let shouldBePublished = false;
    let actionName = offer.id ? 'offers/update' : 'offers/create'
    return store.dispatch(actionName, { offer, shouldBePublished, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList })
  },
  publish({ commit }, { offer, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList}) {
    let shouldBePublished = true;
    let actionName = offer.id ? 'offers/update' : 'offers/create'
    return store.dispatch(actionName, { offer, shouldBePublished, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList})
  },
  republish({ commit }, { offer, options, managersToAddInCopy, potentialCandidatesList}) {
    return new Promise((resolve, reject) => {
      updateAndRepublishOffer(offer, options, managersToAddInCopy, potentialCandidatesList)
      .then( (response) => {
        commit(RESET_OFFER);
        resolve()
      })
      .catch(error => {
        var message = { type: 'danger', content: error.response.data.error }
        store.dispatch('message/enable', message)
      })
    })
  },
  getNumberPotentialCandidates({ commit }, params) {
    return getNumberPotentialCandidates(params)
      .then((response) => {
        commit(SET_POTENTIAL_CANDIDATE_COUNT, response.data.candidates_count);
      })
  },
  getPotentialCandidates({ commit }, params) {
    getNumberPotentialCandidates(params)
      .then((response) => {
        commit(SET_POTENTIAL_CANDIDATE_COUNT, response.data.candidates_count);
      })
    params.response_for_web = true;
    return getPotentialCandidates(params)
      .then((response) => {
        let list = { data: response.data, total: response.headers['x-total'], totalPages: response.headers['x-total-pages'], currentPage: response.headers['x-page']}
        commit(SET_CANDIDATES_LIST, list)
      })
  },
  getRefusingCandidates({ commit }, params) {
  params.response_for_web = true;
  return getCandidatesRefusingOffer(params)
      .then((response) => {
        let list = { data: response.data, total: response.headers['x-total'], totalPages: response.headers['x-total-pages'], currentPage: response.headers['x-page']}
        commit(SET_CANDIDATES_LIST, list)
      })
  },
  getSelectingCandidates({ commit }, params) {
    return getPotentialCandidatesWithoutRefutes(params)
      .then((response) => {
        let list = { data: response.data, total: response.headers['x-total'], totalPages: response.headers['x-total-pages'], currentPage: response.headers['x-page']}
        commit(SET_CANDIDATES_LIST, list)
      })
  },
  getNumberOfRefutes({ commit }, offerId) {
    return getNumberOfRefutes(offerId)
      .then((response) => {
        commit(SET_REFUTES_COUNT, response.data.refutes_count);
      })
  },
  setNumberPotentialCandidates({ commit }, numberPotentialCandidates) {
    commit(SET_POTENTIAL_CANDIDATE_COUNT, numberPotentialCandidates)
  },
  resetPotentialCandidates({ commit }) {
    commit(SET_POTENTIAL_CANDIDATE_COUNT, 0)
    commit(SET_CANDIDATES_LIST, { data: [], total: 0, totalPages: 0, currentPage: 1 })
  },
  setCandidatesListPage({ commit }, page) {
    commit(SET_CANDIDATES_LIST_PAGE, page)
  },
  download({ commit }, params){
    commit(OFFER_EXPORT_LOADING, true);
  
    return downloadOffers(params)
    .then((response) => {
      var blob = new Blob([response.data], { type: params['file_type'] === 'csv' ? 'text/csv' : 'application/vnd.ms-excel' });
      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `export_demandes_${moment().format("YYYY-MM-DD")}.${params['file_type']}`;
      document.body.appendChild(link);
      link.click();
      setTimeout(function(){
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }, 100);
      commit(OFFER_EXPORT_LOADING, false);
    });
  },
  getRefusedCandidates({ commit }, offerId) {
    return getRefusedCandidates(offerId)
      .then((response) => {
        let refusedCandidates = {
          list: response.data.refused_candidates,
          overlap_candidate_ids: response.data.overlap_candidate_ids,
          total: response.headers['x-total'],
          totalPages: response.headers['x-total-pages'],
          currentPage: response.headers['x-page']
        };
        commit(SET_REFUSED_CANDIDATES, refusedCandidates);
      })
  },
  getRefusedCandidatesCount({ commit }, offerId) {
    return getRefusedCandidatesCount(offerId)
      .then((response) => {
        commit(SET_REFUSED_CANDIDATES_COUNT, response.data.refused_candidates_count);
      })
  },
  getSelectingCandidatesCount({ commit }, offerId) {
    return getSelectingCandidatesCount(offerId)
      .then((response) => {
        commit(SET_SELECTING_CANDIDATES_COUNT, response.data.selecting_candidates_count);
      })
  },
  getManagerInCopy({commit}, offerId) {
    return getManagerInCopy(offerId)
    .then((response) => {
      commit(SET_MANAGERS_IN_COPY, response.data);
    })
  },
  setLoadForm({ commit }, loadFormOffer) {
    commit(SET_LOAD_FORM, loadFormOffer);
  },
  setEntityOffer({ commit }, entity) {
    commit(SET_ENTITY_OFFER, entity);
  },
  sendOfferToStaff({ commit }, params) {
    return sendOfferToStaff(params)
      .then((response) => {
        var message = { type: 'success', content: i18n.t('messages.offer_sent_to_staff') }
        store.dispatch('message/enable', message)
      })
  },
  canSendOfferToStaff({ commit }, offerId) {
    return canSendOfferToStaff(offerId)
    .then((response) => {
      commit(SET_CAN_SEND_OFFER_STAFF, response.data);
    })
  }
}

export const getters = {
  offer: state => state.offer,
  offerList: state => state.offerList,
  numberByStatus: state => state.numberByStatus,
  selectedTab: state => state.offerList.selectedTab,
  currentPage: state => state.offerList.currentPage,
  filters: state => state.offerList.filters,
  keepFilters: state => state.offerList.keepFilters,
  potentialCandidatesCount: state => state.potentialCandidatesCount,
  refutesCount: state => state.refutesCount,
  candidatesList: state => state.candidatesList,
  candidatesIdsList: state => state.candidatesIdsList,
  checkedCandidatesList: state => state.checkedCandidatesList,
  candidatesListPage: state => state.candidatesListPage,
  refusedCandidatesCount: state => state.refusedCandidatesCount,
  refusedCandidates: state => state.refusedCandidates,
  selectingCandidatesCount: state => state.selectingCandidatesCount,
  offerStatusCancel: state => state.offerStatusCancel,
  loadFormOffer: state => state.loadFormOffer,
  selectedEntity: state => state.selectedEntity,
  canSendOfferStaff: state => state.canSendOfferStaff,
  managersInCopy: state => state.managersInCopy,
  minSearchLength: state => state.minSearchLength,
  searchWord: state => state.searchWord
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/offers.js